module.exports = __webpack_public_path__ + "img/04.62890a84.jpg";